import { Link } from 'react-router-dom';

const categories = [
  {
    title: 'Best AUS Casinos',
    description: 'Top-rated Australian online casinos with exclusive bonuses',
    iconImage: '/category-icons/pokies.png',
    to: '/best-aus-casinos',
  },
  {
    title: 'My Top Picks',
    description: 'Editor\'s personally curated selection of trusted casinos',
    iconImage: '/category-icons/recommended.png',
    to: '/my-top-picks',
  },
  {
    title: 'Best for Games',
    description: 'Casinos with the largest and best game libraries',
    iconImage: '/category-icons/games.png',
    to: '/best-for-games',
  },
  {
    title: 'Free Games',
    description: 'Play popular casino titles in demo mode with no sign-up',
    iconImage: '/category-icons/games.png',
    to: '/free-games',
  },
];

export default function CategoriesNav() {
  return (
    <section className="py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center md:mb-12 mb-8">
          <h2 className="md:text-3xl text-2xl font-bold text-gray-900 mb-3">
            Explore Casino Categories
          </h2>
          <p className="text-gray-600 text-md">
            Find the perfect casino for your needs with our curated collections
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link
              key={category.to}
              to={category.to}
              className="group bg-white rounded-lg border border-gray-200 p-6 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-gray-50 mb-4 group-hover:scale-110 transition-transform duration-300">
                <img
                  src={category.iconImage}
                  alt={`${category.title} icon`}
                  className="w-11 h-11 object-contain"
                />
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-purple-700 transition-colors">
                {category.title}
              </h3>
              
              <p className="text-gray-600 text-sm mb-4">
                {category.description}
              </p>
              
              <div className="flex items-center text-purple-700 text-sm font-semibold group-hover:translate-x-2 transition-transform duration-300">
                <span>View casinos</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}